import { Theme } from '@mui/material'
import { css } from '@emotion/react'
import { TOP_NAVBAR_HEIGHT } from '@app/app-constants'

export const riskDetailMain = () => css`
  height: 100%;
  display: flex;
  flex-direction: column;
`

export const storyContainer = (theme: Theme) => css`
  padding: ${theme.spacing(4)} ${theme.spacing(4)} ${theme.spacing(4)} ${theme.spacing(2)};
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: center;
  gap: ${theme.spacing(2)};
  overflow-y: scroll;
  position: relative;

  &::-webkit-scrollbar {
    width: 12px !important;
  }

  &::-webkit-scrollbar-track {
    background-color: ${theme.palette.primary.main}00 !important;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${theme.palette.primary.main}40 !important;
    border-radius: 0px !important;
  }
`

export const storyScrollingContainer = () => css`
  position: relative;
  width: 100%;
  height: 100%;
  transition: transform 0.25s ease;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  gap: 16px;
`

export const storyFlexContainer = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  gap: ${theme.spacing(8)};
  padding-bottom: 80vh;
`

export const pageContent = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  padding-left: ${theme.spacing(12)};
  position: relative;
  height: 100%;
  transition: background-color 0.25s ease;
  background-color: ${theme.palette.primary.main}20;
  height: calc(100vh - ${TOP_NAVBAR_HEIGHT}px);
  overflow-y: auto;

  > * {
    transition: filter 0.25s ease;
  }
`

export const riskDetailPageContainer = () => css`
  position: relative;
  display: flex;
  overflow: hidden;
`
export const sideDrawerContainer = css`
  position: relative;
  top: 0;
  left: 0;
  z-index: 100;
`

export const subNavbar = css`
  position: relative;
  top: 0;
  left: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: ${TOP_NAVBAR_HEIGHT}px;
  background-color: #f3f3f3;
  gap: 20px;
  padding: 14px;
  button {
    flex: none;
    font-size: 14px;
    padding: 4px 8px;
  }
`
